(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/helpers/handlebars-helper.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/helpers/handlebars-helper.js');
"use strict";


(function () {
  'use strict';

  function registerHelpers(hbs) {
    hbs.registerHelper('isNotFiltered', function (options) {
      if (!options.data.root.productSetting.allowFiltering) {
        return options.fn(this);
      }
      let anyFilterActive = false;
      _.mapObject(options.data.root.filters, element => {
        anyFilterActive = element || anyFilterActive;
      });

      if (!anyFilterActive) {
        return options.fn(this);
      }
      if (this.sport && this.sport.type > 0) {
        return options.data.root.filters[this.sport.type] ? options.fn(this) : options.inverse(this);
      }
      return options.fn(this);
    });
    hbs.registerHelper('showFilters', function (options) {
      var _options$data;
      if (!(options !== null && options !== void 0 && (_options$data = options.data) !== null && _options$data !== void 0 && (_options$data = _options$data.root) !== null && _options$data !== void 0 && (_options$data = _options$data.productSetting) !== null && _options$data !== void 0 && _options$data.allowFiltering)) {
        return options.inverse(this);
      }
      return options.data.root.availableSports.length > 1 ? options.fn(this) : options.inverse(this);
    });
    hbs.registerHelper('isChecked', function (context, options) {
      return options.data.root.filters[context.type] ? options.fn(this) : options.inverse(this);
    });
  }
  if (svs.isServer) {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }
})();

 })(window);